// .u_amo-input
class UAMOInput extends Uneet {
  constructor (domElement, changeCallback = null) {
    super(domElement)
    this.changeCallback = (changeCallback !== null) ? changeCallback : this.__noop
    this.__init()
  }

  __init () {
    this.input = this._e.querySelectorAll('input')[0]

    this.input.addEventListener('keyup', (e) => {
      this.onChange(e)
    })
  }

  getVariableName () {
    return this.varname
  }

  onChange (e) {
    this.changeCallback(e)
  }

  getURLEncodedValue () {
    return encodeURIComponent(this.input.value)
  }

  clear () {
    this.input.value = ''
  }
}
